import PhotoDocumentDetails from './PhotoDocumentDetails';

export default PhotoDocumentDetails;
